export const isTestEnvironment = (): boolean => {
    const staccEnv = (window as any).stacc_env;

    // Check if the OIDC authority contains 'test.quattro.stacc.dev'
    if (staccEnv?.oidc?.authority) {
        const isTest = staccEnv.oidc.authority.includes('test.quattro.stacc.dev');
        return isTest;
    }

    // Fallback: treat as test environment if we can't determine
    return true;
};